<template>
  <div>
    <v-list
      v-for="(course, index) in courses"
      :key="index"
      class="py-0"
      color="cardSurface"
    >
      <v-list-item>
        <v-list-item-avatar>
          {{ index + 1 }}
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            {{ course.name }}
            <v-icon
              v-if="course.expiryDate && moment().isAfter(course.expiryDate)"
              color="warning"
              dense
            >
              mdi-alert-circle-outline
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle v-if="course.fromDate || course.expiryDate">
            {{ course.fromDate | moment("DD.MM.YYYY") }}
            <span v-if="course.fromDate && course.expiryDate"> - </span>
            <span v-if="course.expiryDate">
              {{ course.expiryDate | moment("DD.MM.YYYY") }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <ExpiryDateDialog
            v-if="course.expiryDate"
            v-model="course.expiryDate"
            label="Utgår"
            :rules="[(v) => !!v || 'Dato må fylles ut!']"
            @change="updateCourse(course)"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="course.expiryDate"
                color="info"
                v-bind="attrs"
                v-on="on"
              >
                mdi-clipboard-edit-outline
              </v-icon>
            </template>
          </ExpiryDateDialog>
          <v-icon class="ml-2" color="error" @click="deleteCourse(course)">
            mdi-delete
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-divider v-if="index + 1 !== courses.length" inset></v-divider>
    </v-list>

    <ConfirmDialog
      v-model="showConfirmDelete"
      title="Bekreft"
      icon="mdi-certificate-outline"
      :text="confirmText"
      btnActionName="Bekreft"
      @action="courseDel"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions } from "vuex";
import moment from "moment";
import ExpiryDateDialog from "@/components/shared/date/ExpiryDateDialog.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";

export default Vue.extend({
  name: "CompetenceList",
  props: {
    loading: {
      type: Boolean,
    },
    courses: {
      type: Array,
    },
  },
  data: () => ({
    showConfirmDelete: false,
    deleteData: {},
    confirmText: "",
    moment,
  }),
  methods: {
    ...mapActions({
      delCourse: "courses/delCourse",
      updateCourse: "courses/updateCourse",
    }),
    deleteCourse(course) {
      this.deleteData = course;
      this.confirmText = `Er du sikker på at du vil slette kurs/sertifikat "${course.name}"?`;
      this.showConfirmDelete = true;
    },
    async courseDel() {
      await this.delCourse(this.deleteData).then(() => {
        this.showConfirmDelete = false;
        this.deleteData = {};
      });
    },
  },
  components: {
    ConfirmDialog,
    ExpiryDateDialog,
  },
});
</script>
